const getters = {
  allGroups: (state) => state.groupList.data,
  allGroupsPending: (state) => state.groupList.status.pending,
};

export default getters;
